import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable, Person } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps, PersonCardImage } from '@shapeable/ui';
import { PersonCardMeta } from './person-card-meta';

const cls = classNames('person-card');

// -------- Types -------->

// -------- Props -------->

export type PersonCardProps = Omit<EntityCardProps, 'entity'> & { 
  entity?: Person;
};

export const PersonCardDefaultProps: Omit<PersonCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
    .shp--entity-card__content {
      gap: ${theme.UNIT(0.5)};
    }
  `,
});

const MetaStyles = breakpoints({
  base: css`
    color: ${theme.COLOR('text')};
  `,
});

const LocationLabelStyles = breakpoints({
  base: css`
    display: flex;
    ${theme.H_DOT_BG()};
    padding-top: ${theme.UNIT(2)};
    color: ${theme.COLOR('text')};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    // TypeLabel: styled.span`${TypeLabelStyles}`,
    Meta: styled(PersonCardMeta)`${MetaStyles}`,
    LocationLabel: styled.span`${LocationLabelStyles}`,
};

export const PersonCard: Shapeable.FC<PersonCardProps> = (props) => {
  const { className, children, entity } = props;

  const { location } = entity || {};

  const hasLocation = !!location;
  
  return (
    <My.Container 
      className={cls.name(className)} 
      entity={entity}
      labelDeriver={() => 'INDIVIDUAL'}
      showImage={false}
      head={
        <PersonCardImage entity={entity} />
      }
      meta={
        <My.Meta entity={entity} />
      }
      foot={
        hasLocation && <My.LocationLabel>{location?.name}{!!location?.state && ', '}{location?.state?.abbr || location?.state?.name}</My.LocationLabel>
      }
      />
  
  )
};

PersonCard.defaultProps = PersonCardDefaultProps;
PersonCard.cls = cls;